export default function GeneratePdfExport(bodyPdf = '', footerPdf = '') {
  const newWindow = window.open('', '', 'width=920, height=700');
  if (!newWindow) return;

  const document = newWindow.document.open();

  const pageContent = `
    <!DOCTYPE html>
    <html lang="pt-BR">
    <head>
      <meta charset="utf-8" />
      <title>Relatório para NFS-e</title>
      <style>
        @page {
          size: A4;
          margin: 12mm;
        }
      </style>
    </head>
    <body>
      ${bodyPdf}
      ${footerPdf}
    </body>
   </html>
  `;

  try {
    document.write(pageContent);
    document.close();
    setTimeout(() => {
      newWindow.focus();
      newWindow.print();
    }, 500);
  } catch (error) {
    // console.log(error);
  }
}
